import { client } from "api";
import { Company } from "models/Company";
import { CompanyOffice } from "models/CompanyOffice";

export type UpdateOfficeRequest = { companyId: Company["id"] } & CompanyOffice;

export type UpdateOfficeResponse = CompanyOffice[];

export const updateOffice = ({ companyId, id, ...officeData }: UpdateOfficeRequest) =>
  client.put<UpdateOfficeResponse>(`/company/${companyId}/offices/${id}`, officeData).then((res) => res.data);
